import { FC } from 'react';
import { Button, Radio, PlusOutlined } from '@fx-ui/fine-design';
import { DataType } from '@fx-ui/jdy-design-biz';
import { isEmpty } from '@libs/shared';
import { RangeType } from '../../../../interfaces';
import ContactValuePanel from '../../../../components/contact-value-panel';

interface RangePickerProps {
    loading?: boolean;
    dataType?: DataType;
    rangeType?: RangeType;
    range?: {
        _id: string;
        name?: string;
    }[];
    options?: {
        label: string;
        value: RangeType;
    }[];
    selectText?: string;
    onSelect?: () => void;
    onSwitch?: (type: RangeType) => void;
}

const RangePicker: FC<RangePickerProps> = ({
    loading,
    dataType,
    rangeType = RangeType.Partial,
    range = [],
    options = [],
    selectText,
    onSelect,
    onSwitch
}) => {
    const renderPicker = () => {
        if (rangeType !== RangeType.Partial) {
            return null;
        }

        if (isEmpty(range)) {
            return (
                <Button
                    className="select-btn"
                    type="text"
                    icon={<PlusOutlined />}
                    onClick={onSelect}
                >
                    {selectText}
                </Button>
            );
        }

        return <ContactValuePanel dataType={dataType} onClick={onSelect} items={range} recursion />;
    };

    return (
        <div className="fx-range-picker">
            <Radio.Group
                direction="horizontal"
                hasPadding={false}
                disabled={loading}
                value={rangeType}
                onChange={onSwitch}
            >
                {options.map((option) => (
                    <Radio key={option.value} value={option.value}>
                        {option.label}
                    </Radio>
                ))}
            </Radio.Group>
            {renderPicker()}
        </div>
    );
};

export default RangePicker;
